<template>
  <div class="container-md col-lg-11 col-md-11 customer-list pb-4 mb-4">
    <div>
      <h3 class="text-primary">Partner List <span class="h5">({{ total }} Record{{ total > 1 ? 's' : '' }})</span></h3>
      <CDataTable
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :items="partners"
        :fields="fields"
        :items-per-page="limit"
        sorter
        :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
        pagination
        class="px-1 border"
        @update:table-filter-value="onSearch"
      >
        <template #action="{ item, index }">
          <td class="py-2">
            <div class="d-flex">
              <CButton
                color="primary"
                square
                size="sm"
                class="mr-1"
                @click="editPartner(item, index)"
                v-c-tooltip="'Edit'"
                ><em class="far fa-edit"></em
              ></CButton>
              <CButton
                color="primary"
                square
                size="sm"
                class="mr-1"
                :to="`/partner/edit-partner-subscription/${item.rawData.customer_organisation_id}`"
                v-c-tooltip="'Edit Subscription'"
                ><em class="fas fa-handshake"></em
              ></CButton>
            </div>
          </td>
        </template>
      </CDataTable>
    </div>
    <CRow class="mt-3">
      <CCol md="12" class="d-flex justify-content-end">
        <Pagination
          :total="query_count"
          :perPage="perPage"
          @pagechanged="pagechanged"
          position="center"
          :showTotalRecords="true"
          :defaultPage="page"
        />
      </CCol>
    </CRow>
    <PartnerEdit
      v-if="partnerEditModal.isShowPopup"
      :partnerDetail="partnerEditModal.data"
      :isShowPopup="partnerEditModal.isShowPopup"
      @modalCallBack="partnerModalCallBack"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PartnerEdit from "@/containers/Partner/EditPartner";
import OrganisationList from "@/containers/Customer/OrganisationList";
import Pagination from "@/components/reusable/Pagination";

export default {
  components: {
    PartnerEdit,
    OrganisationList,
    Pagination,
  },
  data() {
    return {
      page: 1,
      search_value: null,
      perPage: 10,
      total: 0,
      searchTimeout: null,
      query_count: 0,
      collapseDuration: 0,
      collapseIndex: null,
      limit: 10,
      small: true,
      striped: true,
      bordered: true,
      sorter: { external: true, resetable: true },
      fields: [
        {
          key: "name",
          label: "Institution Name",
          _style: "width:25%",
        },
        {
          key: "organisation_type",
          label: "Customer Type",
          _style: "width:15%",
        },
        { key: "main_contact", label: "Main Contact", _style: "width:20%" },

        { key: "tags", _style: "width:15%" },
        { key: "country", _style: "width:15%" },
        {
          key: "action",
          label: "Action",
          sorter: false,
          filter: false,
          _style: "width:10%",
        },
      ],
      partnerEditModal: {
        data: null,
        isShowPopup: false,
      },
      partnerSubEditModal: {
        data: null,
        isShowPopup: false,
      },

      customer_uid: null,
      parent_org_id: null,
      isRecruiterAgency: false,
    };
  },
  computed: {
    ...mapGetters(["getPartnerList"]),
    partners() {
      return (
        (this.getPartnerList &&
          this.getPartnerList.length &&
          this.getPartnerList.map((val) => ({
            name: val.name,
            organisation_type: val.organisation?.organisation_type_name,
            main_contact: val.organisation?.main_contact,
            tags: val?.tags?.join(", ") || "",
            country: val?.country_name || "",
            rawData: val,
          }))) ||
        []
      );
    },
    organisationsFilteredList() {
      return (
        (this.organisationList.length &&
          this.organisationList.filter((val) => {
            return val.organisation_id != this.parent_org_id;
          })) ||
        []
      );
    },
  },
  methods: {
    ...mapActions(["fetchPartners", "updatePartner"]),
    onSearch(value){
      //Apply debounce here
      clearTimeout(this.searchTimeout);
      this.search_value = value;
      this.searchTimeout = setTimeout(() => {
        this.page=1;
      this.fetchPartners({
        ...(this.search_value ? {search_term: this.search_value} : {})
      }).then((res) => {
        this.total = res?.data?.total || 0;
        this.query_count = res?.data?.query_count || 0;
      })
      }, 500);
    },
    pagechanged(pageNumber) {
      if(pageNumber === this.page) {
        return;
      }
      if(pageNumber < 1) {
        return;
      }
      this.page = pageNumber;
      const skip = (pageNumber - 1) * this.perPage;

      this.fetchPartners({
        skip,
        limit: this.perPage,
        ...(this.search_value ? {search_term: this.search_value} : {})
      });
    },
    editPartner(data) {
      this.tooltipHide();
      this.partnerEditModal.isShowPopup = true;
      this.partnerEditModal.data = data.rawData;
      this.partnerEditModal.customerID = data.customer_uid;
    },
    editPartnerSubscription(data) {
      this.tooltipHide();
      this.partnerSubEditModal.isShowPopup = true;
      this.partnerSubEditModal.data = data.rawData;
    },
    partnerModalCallBack(action, payload) {
      if (action === false) {
        this.partnerEditModal.isShowPopup = false;
        this.partnerEditModal.data = null;
      } else if (action === true) {
        let appendAction = this.updatePartner(payload);
        Promise.all([appendAction]).then((res) => {
          if (res) {
            this.partnerEditModal.isShowPopup = false;
            this.partnerEditModal.data = null;
            this.fetchPartners();
          }
        });
      }
    },
    partnerSubEditModalCallBack(action, payload) {
      if (action === false) {
        this.partnerSubEditModal.isShowPopup = false;
        this.partnerSubEditModal.data = null;
      } else if (action === true) {
        let appendAction = this.updatePartner(payload);
        Promise.all([appendAction]).then((res) => {
          if (res) {
            this.partnerSubEditModal.isShowPopup = false;
            this.partnerSubEditModal.data = null;
            this.fetchPartners();
          }
        });
      }
    },

    tooltipHide() {
      setTimeout(() => {
        let x = document.querySelectorAll(".tooltip");
        for (var i = 0; i < x.length; i++) {
          x[i].style.visibility = "hidden";
        }
      }, 50);
    },
  },
  mounted() {
    this.fetchPartners().then((res) => {
      this.total = res?.data?.total || 0;
      this.query_count = res?.data?.query_count || 0;
    });
  },
};
</script>
